import { render, staticRenderFns } from "./zuansu.vue?vue&type=template&id=18cbd6b8&scoped=true&"
import script from "./zuansu.vue?vue&type=script&lang=js&"
export * from "./zuansu.vue?vue&type=script&lang=js&"
import style0 from "./zuansu.vue?vue&type=style&index=0&id=18cbd6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbd6b8",
  null
  
)

export default component.exports